import { useState, useEffect } from 'react';
import api from '../../../services/api';
import { toastSuccess, toastInfo, toastError } from '../../../toasts';
import { useAuth } from '../../../hooks/auth';

export const useMountingProducts = ({ montagem, modal, }) => {
    const [montagemProdutos, setMontagemProdutos] = useState([]);
    const [idProdutos, setIdProdutos] = useState([]);
    const [modalBorda, setModalBorda] = useState(false);
    const { id_empresa } = useAuth();

    const addProduto = async () => {
        try {
            if (idProdutos.length <= 0) {
                throw new Error('Selecione o produto');
            }

            let selected_products = [...idProdutos];

            const { data } = await api.post('montagem-produtos/criar', {
                IdEmpresa: id_empresa,
                IdProdutos: selected_products,
                IdMontagem: montagem.Id,
            });

            setMontagemProdutos(data);
            toastSuccess('Produto inserido na montagema');
            setIdProdutos(data.map((prod) => prod.IdProduto));
        } catch (error) {
            toastError(error.message || 'Não foi possivel adicionar produtos');
        }
    };

    const alterarStatus = async (status, id) => {
        await api
            .post('montagem-produtos/alterarStatus', {
                Status: status,
                Id: id,
            })
            .then(async (res) => {
                setMontagemProdutos((state) => state.map((e) => (e.Id !== res.data.Id ? e : res.data)));
                toastInfo('Produto alterado');
            });
    };

    const deletarProduto = async (id) => {
        await api
            .delete(`montagem-produtos/deletar/${id}`)
            .then(() => {
                setMontagemProdutos((state) => state.filter((x) => x.Id !== id));
            })
            .catch((error) => {
                toastError(error.message || 'Não foi possivel excluir produto');
            });
    };

    const abrirProdutos = async (montagem) => {
        setMontagemProdutos([]);
        await api.get(`montagem-produtos/listar/${montagem.Id}`).then((res) => {
            if (res.data.length > 0) {
                setMontagemProdutos(res.data);
                const ids = res.data.map((prod) => prod.IdProduto);
                setIdProdutos(ids);
            } else {
                setMontagemProdutos([]);
            }
        });
    };

    useEffect(() => {
        abrirProdutos(montagem);
    }, [modal, montagem]);

    return {
        montagemProdutos,
        idProdutos,
        modalBorda,
        setMontagemProdutos,
        setIdProdutos,
        setModalBorda,
        addProduto,
        alterarStatus,
        deletarProduto,
    }
}
